import { generateInitialSchedule } from './utils';

export const FETCH_PROMO_CODES = 'FETCH_PROMO_CODES';
export const FETCH_PROMO_CODE = 'FETCH_PROMO_CODE';
export const UPDATE_PROMO_CODE = 'UPDATE_PROMO_CODE';
export const ADD_PROMO_CODE = 'ADD_PROMO_CODE';
export const DELETE_PROMO_CODE = 'DELETE_PROMO_CODE';

export const PROMO_TYPE = {
  amount: 0,
  percentage: 1,
};

export const initialPromoValues = {
  firstAppointmentOnly: false,
  oneTime: true,
  schedule: generateInitialSchedule(),
  isScheduled: false,
  isUsableEveryNumberOfDays: false,
  services: [],
  products: [],
};
